module.exports = __webpack_public_path__ + "img/217110c.svg";